<template>
	<table class="list_tbl sticky_list_tbl" v-columns-resizable>
		<colgroup>
			<col style="width: 8%;" />
			<col style="width: 8%;" />
			<col style="width: 6%;" />
			<col />
			<col style="width: 10%;" />
			<col style="width: 20%;" />
		</colgroup>
		<thead>
			<tr>
				<th>Valid Receipt Date</th>
				<th>Receipt Type</th>
				<th>Bill To</th>
				<th>Bill To Name</th>
				<th>Receipt Amt</th>
				<th>Check No</th>
			</tr>
		</thead>
		<tbody>
			<template v-for="(date, dateIndex) in root">
				<tr :key="dateIndex">
					<td class="al_center">{{ date.valid_receipt_date }}</td>
					<td colspan="3" class="al_left"></td>
					<td class="al_right"></td>
					<td></td>
				</tr>
				<template v-for="(receipt, receiptIndex) in date.receipt_type_list">
					<tr :key="`${dateIndex}/${receiptIndex}`">
						<td></td>
						<td class="al_center">{{ receipt.receipt_type_code }} {{ receipt.receipt_type_name }}</td>
						<td colspan="2"></td>
						<td class="al_right"></td>
						<td></td>
					</tr>
					<tr v-for="(item, itemIndex) in receipt.receipt_item_list" :key="`${dateIndex}/${receiptIndex}/${itemIndex}`">
						<td></td>
						<td></td>
						<td class="al_left">{{ item.bill_to_code }}</td>
						<td class="al_left truncate" :title="item.bill_to_name">{{ item.bill_to_name }}</td>
						<td class="al_right">{{ item.receipt_item_amount | toCurrency }}</td>
						<td class="al_left">{{ item.check_no }}</td>
					</tr>
					<tr :key="`${dateIndex}/${receiptIndex}/sub`">
						<td></td>
						<td class="al_center">Sub Total</td>
						<td colspan="2"></td>
						<td class="al_right">{{ receipt.total_amount | toCurrency }}</td>
						<td></td>
					</tr>
				</template>
				<tr :key="`${dateIndex}/sub`">
					<td class="al_center">Sub Total</td>
					<td colspan="3"></td>
					<td class="al_right">{{ date.total_amount | toCurrency }}</td>
					<td></td>
				</tr>
			</template>
			<tr>
				<td colspan="4" class="al_right">Grand Total</td>
				<td class="al_right">{{ grandTotal | toCurrency }}</td>
				<td></td>
			</tr>
		</tbody>
	</table>
</template>
<script>
export default {
	name: 'summaryBillTable',
	props: {
		grandTotal: {},
		root: {},
		sortKey: {
			type: String,
			default: '',
		},
		sortDirection: {
			type: String,
			default: '',
		},
	},

	methods: {
		sort(keyword) {
			this.$emit('sort', keyword);
		},

		sort_mark(keyword) {
			if (this.sortKey === keyword) {
				return this.sortDirection === 'ASC' ? '▲' : '▼';
			}
		},
	},
};
</script>
